import { MonitoringSetupErrorSchema } from '../schemas/projectMonitoring'
import { useState } from 'react'
import { AgentPromptBox } from './AgentPrompt'
import { useGetMonitoringSetupQuery } from '../services/sessionMonitoringApi'

export default function ProjectMonitoringSetup({ projectId }: { projectId: string }) {
  const query = useGetMonitoringSetupQuery(projectId)
  const [copied, setCopied] = useState(false)
  const [copyError, setCopyError] = useState(false)
  const credential = query.currentData
  const instructions = credential?.instructions ?? ''
  return <div className="monitoring-setup">
    <p>Give these instructions to the coding agent working on your app.</p>
    {query.isLoading && <p role="status">Preparing setup instructions…</p>}
    {query.isError && <p role="alert">{MonitoringSetupErrorSchema.safeParse(query.error).data?.data.error ?? 'Self-healing setup is unavailable.'} <button onClick={() => void query.refetch()}>Retry</button></p>}
    {credential && <div className="fs-mask"><AgentPromptBox prompt={instructions} copied={copied} analyticsEvent="self-healing-setup-prompt-copy" onCopy={() => {
      setCopyError(false)
      void navigator.clipboard.writeText(instructions).then(() => setCopied(true)).catch(() => setCopyError(true))
    }} /></div>}
    {copyError && <p role="alert">Could not copy. Select and copy the prompt above.</p>}
  </div>
}
